import { render, staticRenderFns } from "./SmsNotificationTemplate.vue?vue&type=template&id=b78a6782&"
import script from "./SmsNotificationTemplate.vue?vue&type=script&lang=js&"
export * from "./SmsNotificationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports